import React , {useEffect , useState} from 'react';
import { useParams } from 'react-router-dom';

//*MUI
import { Box  , Breadcrumbs, ClickAwayListener, Divider , Link} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

//*files
import cssClasses from "./Collaterals.module.css";
import { getProjectByProjectName, getProjectCollaterals } from '../../../Services/SustenanceService';
import FolderIcon from '../../../Assets/Images/Common/folder.svg';
import downloadIcon from '../../../Assets/Images/Common/downloadIcon.svg';
import PDFIcon from '../../../Assets/Images/Common/Pdf.svg';
import PreviewFolderIcon from '../../../Assets/Images/Common/PreviewFolderIcon.svg';
import PreviewExcelIcon from '../../../Assets/Images/Common/PreviewSheetsIcon.svg';
import PreviewFileIcon from '../../../Assets/Images/Common/PreviewFileIcon.svg';
import PreviewPdfIcon from '../../../Assets/Images/Common/PreviewPdfIcon.svg';
import PreviewPowerPointIcon from '../../../Assets/Images/Common/PreviewSlidesIcon.svg';
import PreviewWordIcon from '../../../Assets/Images/Common/PreviewWordIcon.svg';
import shareIcon from '../../../Assets/Images/Common/shareIcon.svg';
import FileIcon from '../../../Assets/Images/Common/file.svg';
import noCollaterals from '../../../Assets/Images/NoCollaterals.svg';
import ImgIcon from '../../../Assets/Images/Common/ImgIcon.svg';
import VideoIcon from '../../../Assets/Images/Common/Video.svg';
import PowerPointIcon from '../../../Assets/Images/Common/MsPowerPoint.svg';
import MsWordIcon from '../../../Assets/Images/Common/MsWord.svg';
import MsExcelIcon from '../../../Assets/Images/Common/MsExcel.svg';

//*Redux
import { useDispatch , useSelector} from 'react-redux';
import action from "../../../Redux Store/actions";
import { dismissLoader, presentLoader } from '../../../Services/loader';
import { downloadFile } from '../../../Services/Drive';
import { errorTost } from '../../../Services/Toast';
import { EmailIcon, EmailShareButton, WhatsappIcon, WhatsappShareButton } from 'react-share';
import PreviewModal from '../../FileManager/PreviewModal';
import ViewCollaterals from '../../../Modals/ViewCollaterals/ViewCollaterals';


function Collaterals() {
  const dispatch = useDispatch();
  const { projectId } = useParams();
  const [projectName, setProjectName] = useState('');
  const [allCollaterals, setAllCollaterals] = useState([]);

  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);

  useEffect(() => {
    dispatch(action.activeMenu('collaterals'));
    getProjectData();
  }, []);



  const [isBreadcrumbChange, setIsBreadcrumbChange] = useState(false);
  const [selectedFolderId, setSelectedFolderId] = useState(null);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [flowSet, setFlowSet] = useState([projectName?.projectName]);
  const [breadcrumbData, setBreadcrumbData] = useState(null);
  const [flowData, setFlowData] = useState([
    <Link
      underline='hover'
      key='3'
      fontFamily={'inter-medium'}
      fontWeight={500}
      fontSize={'1.6rem'}
      color='rgba(29, 41, 57, 1)'
      onClick={() => {
        handleBreadcrumb(null);
      }}
    >
      {projectName?.projectName}
    </Link>,
  ]);

  
  useEffect(() => {
    getAllCollaterals(selectedFolderId);
  }, [selectedFolderId]);

  useEffect(() => {
    console.log("Breadcrumb====>" , flowSet)
    // if (
    //   flowSet?.filter((val) => val.fileName === breadcrumbData.fileName)
    //     ?.length > 0 &&
    //   breadcrumbData !== null
    // ) {
    //   setSelectedFolder(breadcrumbData);
    //   setSelectedFolderId(breadcrumbData?.projectCollateralId);
    //   const index = flowSet?.findIndex(
    //     (val) => val.fileName === breadcrumbData?.fileName
    //   );
    //   const payload = flowSet.slice(0, index + 1);
    //   setFlowSet(payload);
    //   const payload1 = [];
    //   payload.forEach((val) => {
    //     if (typeof val === 'string') {
    //       payload1.push(
    //         <Link
    //           underline='hover'
    //           key='3'
    //           fontFamily={'inter-medium'}
    //           fontWeight={500}
    //           fontSize={'1.6rem'}
    //           color='rgba(29, 41, 57, 1)'
    //           onClick={() => {
    //             handleBreadcrumb(null);
    //           }}
    //         >
    //           {projectName?.projectName}
    //         </Link>
    //       );
    //     } else {
    //       payload1.push(
    //         <Link
    //           underline='hover'
    //           key='3'
    //           fontFamily={'inter-medium'}
    //           fontWeight={500}
    //           fontSize={'1.6rem'}
    //           color='rgba(29, 41, 57, 1)'
    //           onClick={() => {
    //             handleBreadcrumb(val);
    //           }}
    //         >
    //           {val.fileName}
    //         </Link>
    //       );
    //     }
    //   });
    //   setFlowData(payload1);
    // } else if (breadcrumbData === null) {
    //   setSelectedFolder(null);
    //   setSelectedFolderId(null);
    //   console.log("====================" , projectName)
    //   setFlowSet([projectName?.projectName]);
    //   setFlowData([
    //     <Link
    //       underline='hover'
    //       key='3'
    //       fontFamily={'inter-medium'}
    //       fontWeight={500}
    //       fontSize={'1.6rem'}
    //       color='rgba(29, 41, 57, 1)'
    //       onClick={() => {
    //         handleBreadcrumb(null);
    //       }}
    //     >
    //       {projectName?.projectName}
    //     </Link>,
    //   ]);
    // }
  }, [isBreadcrumbChange , projectId]);


  function getAllCollaterals(selectedFolderId) {
    console.log(loggedInUser);
    getProjectCollaterals(
      loggedInUser?.userId,
      projectId,
      selectedFolderId
    ).then((resp) => {
      console.log('projectColateral', resp);
      resp.data = resp.data.map((each, index) => ({
        ...each,
        showShare: false,
      }));
      setAllCollaterals([...resp.data]);
    });
  }


  function getProjectData() {
    getProjectByProjectName(projectId).then((resp) => {
      console.log('Projects-Data', resp.data[0].projectName);
      setProjectName(resp.data[0]);
    });
  }

  const handleBreadcrumb = (value = null) => {
    // setTypeBy("");
    // setDateBy("");
    // setRangeDate([
    //   { label: "StartDate", value: "" },
    //   { label: "EndDate", value: "" },
    // ]);
    setSelectedFolderId(
      value === null ? null : value?.ProjectCollaterals?.projectCollateralId
    );
    setBreadcrumbData(value);
    setIsBreadcrumbChange(!isBreadcrumbChange);
  };

  

  const handleDownloadFile = (value) => {
    presentLoader();

    downloadFile(
      value?.ProjectCollaterals?.fileUrl.split('projectcollaterals/')[1]
    )
      .then((val) => {
        dismissLoader();
        const a = document.createElement('a');
        a.href = URL.createObjectURL(
          new Blob([JSON.stringify(val?.data, null, 2)], {
            type: val?.data?.type,
          })
        );
        a.setAttribute('download', value?.ProjectCollaterals?.fileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch((err) => {
        errorTost(err.message);
        dismissLoader();
      });
  };

  const handleSetToggle = (value) => {
    // setAllCollaterals([]);
    setSelectedFolder(value);
    setSelectedFolderId(value?.ProjectCollaterals?.projectCollateralId);
    setFlowSet((prev) => {
      return [...prev, value?.ProjectCollaterals];
    });
    setFlowData((pre) => {
      return [
        ...pre,
        <Link
          underline='hover'
          key='3'
          fontFamily={'inter-medium'}
          fontWeight={500}
          fontSize={'1.6rem'}
          color='rgba(29, 41, 57, 1)'
          onClick={() => {
            handleBreadcrumb(value);
          }}
        >
          {value.ProjectCollaterals?.fileName}
        </Link>,
      ];
    });
  };
  return (
    <Box className={cssClasses.Container}>
    <Box padding={'2rem'}>
      <Box className={cssClasses.HeaderTitle}>{projectName?.projectName}</Box>
      <Box className={cssClasses.SubTitle}>
        {projectName?.addressLine1},{projectName?.addressLine2},
        {projectName?.addressLine3}
      </Box>
    </Box>

    <Divider variant='middle' />

    <Box overflow={'auto'} height={'100%'}>
      <Box
        className={cssClasses.FlexRow}
        marginTop={'2rem'}
        padding={'0 2.4rem'}
      >
        {allCollaterals.length > 0 && (
          <div className={cssClasses.wrapperCollaterals}>
            <div className={cssClasses.breadcrumbContainer}>
              {/* {flowSet?.length === 1 && (
                <ThreeDotsMenu
                  list={driveFolderOptions}
                  selectedValue={(e) => {
                    if (e?.value === 'Share') {
                      setShowShareModal(true);
                    } else if (e.label === 'Delete') {
                      setShowDeleteModal(true);
                      setSelectedDeleteFile(ProjectData[0]?.projectName);
                    } else if (e.label === 'Download') {
                      handleDownloadFile({
                        fileName: ProjectData[0]?.projectName,
                      });
                    }
                  }}
                />
              )} */}
              {/* <Breadcrumbs
                separator={<NavigateNextIcon fontSize='small' />}
                aria-label='breadcrumb'
              >
                {flowData}
              </Breadcrumbs> */}
            </div>
            {allCollaterals.filter(
              (val) => val?.ProjectCollaterals?.fileType === 'folder'
            )?.length > 0 && (
              <div>
                <div className={cssClasses.folderFileWrapper}>
                  <span style={{ fontSize: '2rem', marginBottom: '1rem' }}>
                    Folders
                  </span>
                  <FileManager
                    value={allCollaterals.filter(
                      (val) => val?.ProjectCollaterals?.fileType === 'folder'
                    )}
                    project={projectName}
                    // handleDeleteFile={(e) => handleDeleteFolder(e)}
                    handleSetToggle={(e) => handleSetToggle(e)}
                    handleDownloadFile={(e) => handleDownloadFile(e)}
                  />
                </div>
              </div>
            )}
            {allCollaterals.filter(
              (val) => val?.ProjectCollaterals?.fileType !== 'folder'
            )?.length > 0 && (
              <div>
                <div className={cssClasses.folderFileWrapper}>
                  <span style={{ fontSize: '2rem ', marginBottom: '1rem' }}>
                    Files
                  </span>
                  <FileManager
                    value={allCollaterals.filter(
                      (v) => v.ProjectCollaterals?.fileType !== 'folder'
                    )}
                    project={projectName}
                    // handleDeleteFile={(e) => handleDeleteFile(e)}
                    handleSetToggle={(e) => handleSetToggle(e)}
                    handleDownloadFile={(e) => handleDownloadFile(e)}
                  />
                </div>
              </div>
            )}
          </div>
        )}
        
      
      </Box>

      {allCollaterals.length === 0 && (
          <div className={cssClasses.wrapperCollaterals}>
            <div className={cssClasses.breadcrumbContainer}>
              {/* <Breadcrumbs
                separator={<NavigateNextIcon fontSize='small' />}
                aria-label='breadcrumb'
              >
                {flowData}
              </Breadcrumbs> */}
              <div className={cssClasses.noDataMsg} >
                <div className={cssClasses.emptyIcon}>
                  <img src={noCollaterals} alt='No Collaterals' />
                </div>
                <div className={cssClasses.emptyTitle}>
                  No Collaterals Found
                </div>
              </div>
            </div>
          </div>
        )}
    </Box>

   
  </Box>
  );
}

const FileManager = ({
    value,
    handleSetToggle,
    handleDeleteFile,
    handleDownloadFile,
    project,
  }) => {
    const [data, setData] = useState([]);
    const [selectedFile, setSelectedFile] = useState();
    const [selectManagerModalOpen, setSelectManagerModalOpen] = useState(false);
    const [showRenameModal, setShowRenameModal] = useState(false);
    const [selectedFileName, setSelectedFileName] = useState('');
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [fileOptions, setFileOptions] = useState([
      { id: 0, value: 'Share', label: 'Share' },
      { id: 1, value: 'Copy Link', label: 'Copy Link' },
      { id: 2, value: 'Preview', label: 'Preview' },
      { id: 3, value: 'Download', label: 'Download' },
    ]);
    const [folderOptions, setFolderOptions] = useState([
      { id: 0, value: 'Share', label: 'Share' },
      // { id: 1, value: "Download", label: "Download" },
      { id: 2, value: 'Delete', label: 'Delete' },
    ]);
  
    useEffect(() => {
      if (value?.length > 0) {
        setData(value);
      }
    }, [value]);
  
    const handleOpenPreviewModal = (value) => {
      setShowPreviewModal(true);
      console.log('---->', value);
      setSelectedFile(value);
    };
  
    return (
      <div className={cssClasses.mainWrapper}>
        <div className={cssClasses.fileManagerContainer}>
          {data.map((each, index) => {
            return (
              <div
                className={cssClasses.folderWrapper}
                onDoubleClick={() => {
                  each?.ProjectCollaterals?.fileType === 'folder' &&
                    handleSetToggle(each);
                }}
              >
                <div>
                  {each?.ProjectCollaterals?.fileType !== 'video' ? (
                    <img
                      src={
                        each.ProjectCollaterals?.fileType === 'folder'
                          ? PreviewFolderIcon
                          : each?.ProjectCollaterals?.fileType === 'image'
                          ? process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                            each?.ProjectCollaterals?.fileUrl
                          : each?.ProjectCollaterals?.fileType === 'SpreadSheet'
                          ? PreviewExcelIcon
                          : each?.ProjectCollaterals?.fileType === 'Word File'
                          ? PreviewWordIcon
                          : each?.ProjectCollaterals?.fileType === 'Presentation'
                          ? PreviewPowerPointIcon
                          : each?.ProjectCollaterals?.fileUrl.includes('.pdf')
                          ? PreviewPdfIcon
                          : PreviewFileIcon
                      }
                      className={`${
                        each?.ProjectCollaterals?.fileType === 'image'
                          ? cssClasses.imgContainer
                          : ''
                      }`}
                      alt='icon'
                      onClick={() => {
                        (each?.ProjectCollaterals?.fileType === 'image' ||
                          each?.ProjectCollaterals?.fileType === 'SpreadSheet' ||
                          each?.ProjectCollaterals?.fileType === 'Word File' ||
                          each?.ProjectCollaterals?.fileType === 'Presentation' ||
                          each?.ProjectCollaterals?.fileUrl.includes('.pdf')) &&
                          handleOpenPreviewModal(each);
                      }}
                    />
                  ) : (
                    <video
                      src={
                        process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                        each?.ProjectCollaterals?.fileUrl
                      }
                      alt='video'
                      className={cssClasses.imgContainer}
                      onClick={() => handleOpenPreviewModal(each)}
                    />
                  )}
                </div>
                <div className={cssClasses.iconWrapper}>
                  <img
                    src={
                      each?.ProjectCollaterals?.fileType === 'folder'
                        ? FolderIcon
                        : each?.ProjectCollaterals?.fileType === 'image'
                        ? ImgIcon
                        : each?.ProjectCollaterals?.fileType === 'SpreadSheet'
                        ? MsExcelIcon
                        : each?.ProjectCollaterals?.fileType === 'Word File'
                        ? MsWordIcon
                        : each?.ProjectCollaterals?.fileType === 'Presentation'
                        ? PowerPointIcon
                        : each?.ProjectCollaterals?.fileUrl.includes('.pdf')
                        ? PDFIcon
                        : each?.ProjectCollaterals?.fileType === 'video'
                        ? VideoIcon
                        : FileIcon
                    }
                    alt='icon'
                  />
                  <span className={cssClasses.label}>
                    {each?.ProjectCollaterals?.fileName}
                  </span>{' '}
                  <div className={cssClasses.wrapperTitle}>
                    <div className={cssClasses.Title}>
                      {each?.ProjectCollaterals?.collateralUrl?.substring(
                        each?.ProjectCollaterals?.collateralUrl?.lastIndexOf(
                          '/'
                        ) + 1
                      )}
                    </div>
                    {each?.ProjectCollaterals?.fileType !== 'folder' && (
                      <>
                        <div className={cssClasses.wrapperShareDownload}>
                          <img
                            style={{ cursor: 'pointer' }}
                            src={downloadIcon}
                            alt='downloadIcon'
                            onClick={() => handleDownloadFile(each)}
                          ></img>
  
                          <img
                            src={shareIcon}
                            alt='shareIcon'
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setData((pre) => {
                                pre[index].showShare = true;
                                return [...pre];
                              });
                            }}
                          />
                          {each.showShare && each === data[index] && (
                            <ClickAwayListener
                              onClickAway={() => {
                                setData((pre) => {
                                  pre[index].showShare = false;
                                  return [...pre];
                                });
                              }}
                            >
                              <div className={cssClasses.wrapperShare}>
                                <WhatsappShareButton
                                  url={
                                    process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                                    each.ProjectCollaterals?.fileUrl
                                  }
                                  title={project.projectName}
                                >
                                  <WhatsappIcon size={32} round={true} />
                                </WhatsappShareButton>
                                <EmailShareButton subject={project.projectName}>
                                  <EmailIcon size={32} round={true}></EmailIcon>
                                </EmailShareButton>
                              </div>
                            </ClickAwayListener>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {showPreviewModal && (
          <ViewCollaterals
            open={showPreviewModal}
            handleClose={() => {
              setShowPreviewModal(false);
            }}
            value={selectedFile}
            fileOptions={fileOptions}
            setSelectManagerModalOpen={setSelectManagerModalOpen}
            setSelectedFile={setSelectedFile}
          />
        )}
      </div>
    );
  };

export default Collaterals;
